export default __webpack_public_path__ + "/dist/images/delete.33379accd43197a70d8eaaddeb72f8aa.svg";